export const makeCursorFromPage = (itemsPerPage: number, page?: number) => {
  if (!page || page <= 1) {
    return;
  }

  const indexOfLastItem = (page - 1) * itemsPerPage - 1;

  return window.btoa(`${indexOfLastItem}`);
};
